import React from "react";
//import { Container, Box, Typography } from "@mui/material";
import { Container, Box, Typography, Link, IconButton, useMediaQuery } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { useTheme } from "@mui/material/styles"
import { useTranslation } from "react-i18next";
//import "./Footer.css"; // 👈 Stil dosyasını ekledik

function Footer() {

    const { t } = useTranslation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        //Last Footer change
        <Box
            component="footer"
            sx={{
                backgroundColor: "#76959c",
                color: "#fff",
                minHeight: "100px", // set a fixed minimum height
                py: 1, // padding top and bottom
                mt: 0, // margin top
                //display: "flex",
                display: "block",
                alignItems: "center",
                //position: isMobile ? "static" : "static", // Mobilde static, webde fixed
                position: "static",
                //bottom: isMobile ? "auto" : 0,
                //left: 0,
                //width: "100%",
                //zIndex: 1300,
            }}
        >
            <Container maxWidth="md">
                <Box
                    display="flex"
                    //display = "block"
                    justifyContent="space-between"
                    flexDirection={{ xs: "column", md: "row" }}
                    textAlign={{ xs: "center", md: "left" }}
                    //gap={4}
                >
                    {/* <Box
                        sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: { xs: "center", md: "flex-start" },
                        gap: 4, // ikonlar arası boşluk
                        mt: 1,
                        }}
                    > */}


                    {/* © Yılı ve Şirket Adı */}
                    <Box>
                        &nbsp;
                        <Typography variant="body2">
                            {t("footer.copyright")}
                        </Typography>
                    </Box>
                    {/* Box 1 */}
                    <Box>
                        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                            {t("footer.about")}
                        </Typography>
                        <Typography variant="body2">
                            {t("footer.terms")}
                        </Typography>
                    </Box>
           
                    {/* <Box>
                        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                            Politikalarımız
                        </Typography>
                        <Typography variant="body2">
                            Kullanım Koşulları ve Gizlilik
                        </Typography>
                    </Box> */}

                    {/* Box 2 */}
                    <Box>
                        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                            {t("footer.contact")}
                        </Typography>
                        <Typography variant="body2">
                            <b>{t("footer.addressLabel")}:</b> {t("footer.address")}
                        </Typography>
                        <Typography variant="body2">
                            <b>{t("footer.emailLabel")}:</b> {t("footer.email")}
                        </Typography>
                        <Typography variant="body2">
                            <b>{t("footer.phoneLabel")}:</b> {t("footer.phone")}
                        </Typography>
                    </Box>

                    {/* Box 3 */}
                    <Box>
                        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                            {t("footer.followUs")}
                        </Typography>
                        
                        {/* Sosyal Medya İkonları */}
                        <Box>
                            <IconButton
                                aria-label="Facebook"
                                href="https://facebook.com"
                                target="_blank"
                                sx={{ color: "#fff" }}
                            >
                            <FacebookIcon />
                            </IconButton>

                            {/* <IconButton
                                aria-label="Twitter"
                                href="https://twitter.com"
                                target="_blank"
                                sx={{ color: "#fff" }}
                            >
                            <TwitterIcon />
                            </IconButton> */}

                            <IconButton
                                aria-label="Instagram"
                                href="https://instagram.com"
                                target="_blank"
                                sx={{ color: "#fff" }}
                            >
                            <InstagramIcon />
                            </IconButton>

                            <IconButton
                                aria-label="LinkedIn"
                                href="https://www.linkedin.com/"
                                target="_blank"
                                sx={{ color: "#fff" }}
                            >
                            <LinkedInIcon />
                            </IconButton>
                        </Box>


                    </Box>
                </Box>
            </Container>
        </Box>
    );
}

export default Footer;
